import { useMemo, useRef } from 'react';
import {
  updateDingTalk,
  UpdateDingTalkBody,
  updateInsiteEnable,
  UpdateInsiteEnableBody,
  updateInsiteScene,
  UpdateInsiteSceneBody,
  updateOutsite,
  UpdateOutsiteBody,
  deleteDingTalk,
  DeleteDingTalkParams,
} from 'services/api/remind';

function useConfig({ onUpdated }: { onUpdated: () => Promise<any> }) {
  const refsCurrent = { onUpdated };
  const refs = useRef(refsCurrent);
  refs.current = refsCurrent;

  return useMemo(() => {
    const update = (updater: () => Promise<any>) => {
      return updater().then(refs.current.onUpdated);
    };

    return {
      updateInsiteEnable: (body: UpdateInsiteEnableBody) => update(() => updateInsiteEnable(body)),
      updateInsiteScene: (body: UpdateInsiteSceneBody) => update(() => updateInsiteScene(body)),
      updateOutsite: (body: UpdateOutsiteBody) => update(() => updateOutsite(body)),
      updateDingTalk: (body: UpdateDingTalkBody) => update(() => updateDingTalk(body)),
      deleteDingTalk: (params: DeleteDingTalkParams) => update(() => deleteDingTalk(params)),
    };
  }, []);
}

export default useConfig;
